import { addTotals } from 'checkout/lib/utils/payments/totals'
import { createSelector } from 'reselect'
import { getAccommodationTotals } from './accommodation'
import { getFlightTotals, getFlightsDateChangeFees } from './flights'

/**
 * Payable totals for Passport quotes: getAccommodationTotals already rolls up LE hotel, bedbank,
 * tour v2, cruise, and tour v1 via checkoutAccommodationOfferView; plus flights and flight date-change fees.
 * (Experiences and other non-quote verticals stay excluded — see getTotalsWithoutInsurance.)
 */
const getPassportCardTotalsWithoutInsurance = createSelector(
  (state: App.State) => getAccommodationTotals(state),
  (state: App.State) => getFlightTotals(state),
  (state: App.State) => getFlightsDateChangeFees(state),
  (...itemTotals: Array<App.WithDataStatus<App.Checkout.ItemViewTotals>>): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    return addTotals(itemTotals)
  },
)

export default getPassportCardTotalsWithoutInsurance
